var _rect, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61,
    height: 61,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "mail_icon 1",
    width: 61,
    height: 61,
    x: 0,
    y: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u0424\\u043E\\u0440\\u043C\\u0430 7",
    d: "M53.375 20.332L44.3246 25.36C39.2789 28.1632 36.7561 29.5649 34.0843 30.1144C31.7195 30.6006 29.2805 30.6006 26.9157 30.1144C24.244 29.5649 21.7212 28.1632 16.6754 25.36L7.625 20.332M45.2417 48.2904C48.0886 48.2904 49.5122 48.2904 50.5995 47.7363C51.5559 47.249 52.3337 46.4713 52.8209 45.5149C53.375 44.4275 53.375 43.0039 53.375 40.157L53.375 20.8404C53.375 17.9934 53.375 16.57 52.8209 15.4826C52.3337 14.5261 51.5559 13.7484 50.5995 13.2611C49.5122 12.707 48.0886 12.707 45.2417 12.707L15.7583 12.707C12.9114 12.707 11.4879 12.707 10.4006 13.2611C9.44405 13.7484 8.6664 14.5261 8.17906 15.4826C7.625 16.57 7.625 17.9934 7.625 20.8404L7.625 40.157C7.625 43.0039 7.625 44.4275 8.17906 45.5149C8.6664 46.4713 9.44405 47.249 10.4006 47.7363C11.4879 48.2904 12.9114 48.2904 15.7583 48.2904L45.2417 48.2904Z",
    fillRule: "nonzero",
    stroke: "rgb(133,0,0)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.223fd4de8660877ef3de7dd312f920cd.svg";
export { ForwardRef as ReactComponent };